import { styled, Tooltip } from '@mui/material';
import { Grid } from '@mui/system';
import { TextCellProps } from './TextCell.props';

const PREFIX = 'TextCell';

const classes = {
  tooltip: `${PREFIX}-tooltip`,
};

const StyledGrid = styled(Grid)(() => ({
  [`& .${classes.tooltip}`]: {
    margin: '0px',
  },
}));

const CustomTooltip = Tooltip;

const TextCell = (props: TextCellProps) => {
  const { children, shouldDisplayTooltip, textRef } = props;

  return (
    <StyledGrid className="text-cell" component="span">
      <Grid component="span">
        {shouldDisplayTooltip ? (
          <CustomTooltip
            classes={{
              tooltip: classes.tooltip,
            }}
            placement="bottom-end"
            title={children?.toString() ?? ''}>
            <Grid component="span">{children}</Grid>
          </CustomTooltip>
        ) : (
          <Grid component="span">{children}</Grid>
        )}
      </Grid>

      {/* Hidden text-measure for ellipsis/tooltip */}
      <Grid className="text-cell-measure" component="span" ref={textRef}>
        {children}
      </Grid>
    </StyledGrid>
  );
};

export default TextCell;
